import { useEffect } from "react"

import { Form } from "@/components/forms/Form"
import { RadioField } from "@/components/forms/RadioField"
import { TextField } from "@/components/forms/TextField"
import { Textarea } from "@/components/forms/Textarea"
import type { LicenseData } from "@/hooks/useLicenseStore"
import { useStrings } from "@/hooks/useStrings"
import type { UseFormReturn } from "react-hook-form"
import { ChoiceField } from "@/components/forms/ChoiceField"
import { CheckboxField } from "@/components/forms/CheckboxField"

type ConditionsProps = {
  form: UseFormReturn<LicenseData>
}

export const Conditions = ({ form }: ConditionsProps) => {
  const hasExpiry = form.watch("hasExpiry") === 'yes'

  const immutableText = hasExpiry
    ? 'I understand that once I release a dataset to a recipient under this Data Sharing License, the license will remain in effect until the specified end date. Until that date, I cannot revoke it or change the terms for that recipient.'
    : 'I understand that once I release a dataset to a recipient under this Data Sharing License, I cannot revoke it or change the terms for that recipient.'

  return (
    <Form form={form}>
      <div className={'flex flex-col gap-4'}>
      <CheckboxField
        form={form}
        name="acceptedAuthorization"
        // label="Confirm that it is appropriate to issue the data license. *"
        checkboxLabel="I am responsible for the data and have the authority to create the Data Sharing License."
      />
      <CheckboxField
        form={form}
        name="acceptedMutability"
        // label="This license is irrevocable and immutable *"
        checkboxLabel={immutableText}
      />
      <CheckboxField
        form={form}
        name="acceptedTerms"
        // label="Terms of the Data Sharing License *"
        checkboxLabel={
          <>
            I have read and understand the{" "}
            <a href="#/terms" className="text-emerald-700 underline underline-offset-2 hover:text-emerald-800">
              terms and conditions
            </a>{" "}
            of the Data Sharing License.
          </>
        }
      />
      </div>
    </Form>
  )
}
